/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import shortid from 'shortid';
import { webUrlRegexp } from '../../utils';
import styled from '../../styled';
const Wrapper = styled.span `
  ${({ isPreserveLine }) => isPreserveLine &&
    `
    white-space: pre-line;
  `}
`;
const TextLink = React.memo(({ text, isPreserveLine = false }) => (React.createElement(React.Fragment, null, text.split(webUrlRegexp).map(w => {
    if (webUrlRegexp.test(w)) {
        return (React.createElement("a", { href: w, key: shortid.generate(), target: "_blank" }, w));
    }
    return React.createElement(Wrapper, { isPreserveLine: isPreserveLine }, w);
}))));
export default TextLink;
//# sourceMappingURL=index.js.map